import { PASSWORD_RULES } from '@ruby/shared';
import { Check, Circle } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Live checklist under password fields so users see requirements before submitting. */
export function PasswordRules({ value }: { value: string }) {
  return (
    <ul className="grid grid-cols-2 gap-x-3 gap-y-1 text-xs" aria-label="Password requirements">
      {PASSWORD_RULES.map((r) => {
        const ok = r.test(value ?? '');
        return (
          <li key={r.label} className={cn('flex items-center gap-1.5', ok ? 'text-success' : 'text-fg-subtle')}>
            {ok ? <Check className="size-3.5" /> : <Circle className="size-3" />}
            {r.label}
          </li>
        );
      })}
    </ul>
  );
}
